import React from 'react';
import cn from 'classnames';

import { Icon, InlineIcon } from '@iconify/react';
import iconCheck from '@iconify-icons/mdi/check';
import { TRANSLATIONS } from '../../../../translations';

const ModalSuccess = () => {
  return (
    <div className="modal-partner-signup success">
      <Icon icon={iconCheck} className={cn('icon')} />
      <p>{TRANSLATIONS.REGISTRATION_COMPLETE}</p>
    </div>
  )
}

export default ModalSuccess;
